<template>
  <NsHeroBanner />
  <NsProductShowcase />
  <NsOfficialPartner />
  <NsFeatureSection />
  <NsBackendFeatures />
  <NsShoppingExperience />
  <NsEmpowerVendors />
  <NsHeadlessTech />
  <NsPerformanceSection />
  <NsThirdPartyTool />
  <NsPriceSection />
  <NsCompetitorInsights />
  <NsRequestDemo />
  <NsFaqSection />
  <NsJoinWaitlistSection />
</template>

<script setup lang="ts">

const  NsCompetitorInsights  = defineAsyncComponent(() => import('~/components/NsCompetitorInsights.vue'));
const NsPerformanceSection = defineAsyncComponent(() => import('~/components/NsPerformanceSection.vue'));
const NsProductShowcase = defineAsyncComponent(() => import('~/components/NsProductShowcase.vue'));
const NsThirdPartyTool = defineAsyncComponent(() => import('~/components/NsThirdPartyTool.vue'));
const NsHeroBanner = defineAsyncComponent(() => import('~/components/NsHeroBanner.vue'));
const NsShoppingExperience = defineAsyncComponent(() => import('~/components/NsShoppingExperience.vue'));
const NsEmpowerVendors = defineAsyncComponent(() => import('~/components/NsEmpowerVendors.vue'));
const NsOfficialPartner = defineAsyncComponent(() => import('~/components/NsOfficialPartner.vue'));
const NsFeatureSection = defineAsyncComponent(() => import('~/components/NsFeatureSection.vue'));
const NsHeadlessTech = defineAsyncComponent(() => import('~/components/NsHeadlessTech.vue'));
const NsPriceSection = defineAsyncComponent(() => import('~/components/NsPriceSection.vue'));
const NsRequestDemo = defineAsyncComponent(() => import('~/components/NsRequestDemo.vue'));
const NsFaqSection = defineAsyncComponent(() => import('~/components/NsFaqSection.vue'));
const NsBackendFeatures = defineAsyncComponent(() => import('~/components/NsBackendFeatures.vue'));
const NsJoinWaitlistSection = defineAsyncComponent(() => import('~/components/NsJoinWaitlistSection.vue'));

useHead({
  title: 'Nuxt.store - E-commerce Platform',
  meta: [
    { name: 'description', content: 'Level up your e-commerce with our composable frontend solution' }
  ]
})
</script>

<style scoped>
:deep(.p-slider .p-slider-range) {
  background: #10b981;
}

:deep(.p-slider .p-slider-handle) {
  background: #10b981;
  border-color: #10b981;
}

:deep(.p-inputtext) {
  background: #334155 !important;
  border-color: #475569 !important;
  color: white !important;
}

:deep(.p-inputtext:focus) {
  border-color: #10b981 !important;
  box-shadow: 0 0 0 0.2rem rgba(16, 185, 129, 0.2) !important;
}

:deep(.p-card) {
  background: rgba(30, 41, 59, 0.5) !important;
  border: 1px solid #475569 !important;
  backdrop-filter: blur(4px);
}

:deep(.p-card .p-card-content) {
  padding: 1.5rem !important;
}

:deep(.p-rating .p-rating-icon) {
  color: #fbbf24 !important;
}
</style>
